import { MapPin, Phone, MessageCircle, Mail } from "lucide-react";
import { CLINIC, telLink, waLink } from "../../lib/clinic";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[hsl(var(--navy))] text-[hsl(var(--cream))]/80 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="grid place-items-center w-11 h-11 rounded-full overflow-hidden bg-black/40 ring-1 ring-white/10">
                <img src={CLINIC.logoUrl} alt="Cardiología Avanzada" className="w-full h-full object-cover" loading="lazy" />
              </span>
              <div className="leading-tight">
                <div className="font-serif-display text-lg text-[hsl(var(--cream))]">
                  {CLINIC.doctorName}
                </div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-[hsl(var(--cream))]/60 mt-0.5">
                  Cardiología Avanzada · Aguascalientes
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              Cardiología · Cuidados Coronarios · Ecocardiografía · Especialista en terapia ECMO.
              Diagnóstico integral, trato humano y la confianza de la vieja escuela.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--cream))]/60 mb-4">
              Consultorios
            </div>
            <div className="space-y-4 text-sm">
              {CLINIC.consultorios.map((c) => (
                <div key={c.id} className="flex items-start gap-2.5">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[hsl(var(--soft-red))]" />
                  <div>
                    <div className="text-[hsl(var(--cream))] font-medium">{c.name}</div>
                    <div className="text-xs">{c.addressLine2}</div>
                    <div className="text-xs">{c.city}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--cream))]/60 mb-4">
              Contacto directo
            </div>
            <div className="space-y-3 text-sm">
              <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 hover:text-[hsl(var(--soft-red))] transition-colors group">
                <MessageCircle className="w-4 h-4 group-hover:scale-110 transition-transform" />
                WhatsApp · {CLINIC.whatsappDisplay}
              </a>
              <a href={telLink} className="flex items-center gap-2.5 hover:text-[hsl(var(--soft-red))] transition-colors">
                <Phone className="w-4 h-4" /> Tel · {CLINIC.phoneDisplay}
              </a>
              <a href={`tel:${CLINIC.emergencyNumber}`} className="flex items-center gap-2.5 hover:text-[hsl(var(--soft-red))] transition-colors">
                <Phone className="w-4 h-4 text-[hsl(var(--soft-red))]" /> Urgencias · {CLINIC.emergencyDisplay}
              </a>
              <a href={`mailto:${CLINIC.email}`} className="flex items-center gap-2.5 hover:text-[hsl(var(--soft-red))] transition-colors">
                <Mail className="w-4 h-4" /> {CLINIC.email}
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-[hsl(var(--cream))]/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-[hsl(var(--cream))]/60">
          <p>
            © {new Date().getFullYear()} {CLINIC.doctorName}. Todos los derechos reservados.
          </p>
          <p className="italic">
            Aviso: este sitio es informativo y no sustituye una consulta médica.
            Si presentas síntomas urgentes, acude al servicio de urgencias.
          </p>
        </div>
      </div>
    </footer>
  );
};
